/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* C block for DEMs
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';

/*
* Add new layer to the map
* User can select which bands to visualize as RGB
*/
Blockly.Blocks['output_dem_vis'] = {
    init: function () {
        let layerNameValidator = newValue => {
            let maxLength = 20;
            let cleanValue = newValue.replace(/[^a-zA-Z0-9 ]/g, "");
            let trimmedValue = cleanValue.substring(0, maxLength)
            return trimmedValue;
        }

        this.appendDummyInput()
            .appendField("DEM visualisation.  Parameter ")
            .appendField(new Blockly.FieldDropdown([["DEM", "dem"], ['Coloured DEM', 'coloured_dem'], ['Coloured hillshade DEM', 'hillshade_dem'], ["Slope", "slope"], ["Aspect", "aspect"], ["Hillshade", "hillshade"]]), "param")
        this.appendDummyInput()
            .appendField("Layer name: ")
            .appendField(new Blockly.FieldTextInput("default", layerNameValidator), "layerName");

        this.getField("layerName").setTooltip(Blockly.Msg.LAYER_NAME_TOOLTIP)
        this.setPreviousStatement(true, 'dem_vis');
        this.setNextStatement(true, getAllowedOutputs('dem_vis'));
        this.setStyle('mapVisualisation');
        this.setTooltip(Blockly.Msg.DEM_VIS_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    }
};